import { EBuildingClassType, EOfficeType } from '../../api-models/common/json_query';
import { WAREHOUSE_GROUP } from '../constants/officeTypeGroups';

const ABC: EBuildingClassType[] = [EBuildingClassType.A, EBuildingClassType.B, EBuildingClassType.C];
const ABCD: EBuildingClassType[] = [...ABC, EBuildingClassType.D];

const CLASS_D_TYPES: EOfficeType[] = [...WAREHOUSE_GROUP, EOfficeType.Building];

export const getBuildingClassTypeFields = (officeTypes: EOfficeType[]): EBuildingClassType[] => {
  if (!officeTypes.length) {
    return ABCD;
  }

  if (officeTypes.every(field => CLASS_D_TYPES.includes(field))) {
    return ABCD;
  }

  return ABC;
};
